import ReactLoadable from "@react-loadable/revised";

/**
 * @react-loadable/revised 는 import() 결과에 `__esModule` 표시가 있을 때만 `.default` 를 꺼낸다.
 * webpack 은 이 표시를 붙였지만 브라우저 네이티브 ESM(Vite dev)·Rollup 빌드는 붙이지 않아
 * 모듈 객체가 통째로 컴포넌트 자리에 들어간다. 표시를 붙여 기존 동작을 유지한다.
 * 모든 Loadable 은 원본 대신 이 래퍼를 import 한다 (.eslintrc no-restricted-imports).
 *
 * @param {object} mod import() 로 받은 모듈 객체
 * @returns {object} `__esModule` 이 붙은 모듈 객체
 */
const markAsEsModule = (mod) => (mod && typeof mod === "object" && !mod.__esModule ? { __esModule: true, ...mod } : mod);

/**
 * @param {object} options @react-loadable/revised 의 옵션 그대로
 * @returns {import("react").ComponentType} 지연 로드 컴포넌트
 */
const Loadable = (options) => ReactLoadable({ ...options, loader: () => options.loader().then(markAsEsModule) });

export default Loadable;
